class TabsItem {
  constructor(element) {
    this.element = element;
    this.buttons = this.element.querySelectorAll('[data-element="tabs-item-btn"]');
    this.contents = this.element.querySelectorAll('[data-element="tabs-item-content"]');

    this.firstButton = this.buttons[0];
    this.firstContent = this.contents[0];
  }

  init() {
    this.setFirstItemActive();
    this.buttons.forEach((button) => {
      button.addEventListener('click', this.buttonOnClick.bind(this, button));
    });
  }

  setFirstItemActive() {
    this.firstButton.classList.add('is-active');
    this.firstContent.classList.add('is-active');
  }

  buttonOnClick(...args) {
    const button = args[0];
    const content = this.element.querySelector('[data-tab="' + button.dataset.target + '"]');
    this.setItemActive(button, content);
  }

  setItemActive(button, content) {
    this.removeAllItemsActive();
    button.classList.add('is-active');
    content.classList.add('is-active');
  }

  removeAllItemsActive() {
    this.buttons.forEach((button) => {
      button.classList.remove('is-active');
    });

    this.contents.forEach((content) => {
      content.classList.remove('is-active');
    });
  }
}

const tabs = {
  init() {
    const tabsItems = document.querySelectorAll('[data-module="tabs"]');

    if (tabsItems) {
      tabsItems.forEach((item) => {
        const tabsItem = new TabsItem(item);
        tabsItem.init();
      });
    }
  },
};

export default tabs;
